import { ISelectOption } from '@aon/aon-tws-common-ui';
import _ from 'lodash';
import { Reducer } from 'redux';
import { ICulture } from '../models';
import * as CultureAPI from '../services/CultureAPI';
import { IApplicationState } from './';
import { ICulturesGetFailed, ICulturesGetRequested, ICulturesGetSuccessful } from './Actions';
import { ActionTypes } from './ActionTypes';

export interface ICulturesState {
	culturesLoading: boolean;
	availableCultures: ISelectOption[];
}

export const defaultState: ICulturesState = {
	culturesLoading: false,
	availableCultures: [],
};

const getCulturesInternal = (dispatch: any) => {
	dispatch({ type: ActionTypes.CULTURES_GET_REQUESTED });
	return CultureAPI.getCultures()
		.then((cultures: ICulture[]) => dispatch({ type: ActionTypes.CULTURES_GET_SUCCESSFUL, payload: cultures }))
		.catch(() => dispatch({ type: ActionTypes.CULTURES_GET_FAILED }));
};
export const ActionCreators = {
	GetCultures: () => getCulturesInternal,
	GetCulturesIfNeeded: () => (dispatch: any, getState: () => IApplicationState) => {
		if (!getState().cultures.availableCultures.length) {
			return getCulturesInternal(dispatch);
		}
		return;
	},
};

type KnownActions = ICulturesGetFailed | ICulturesGetRequested | ICulturesGetSuccessful;

export const reducer: Reducer<ICulturesState, KnownActions> = (state: ICulturesState | undefined, action: KnownActions) => {
	if (!state) {
		return defaultState;
	}
	switch (action.type) {
		// CULTURES
		case ActionTypes.CULTURES_GET_FAILED:
			return { ...state, culturesLoading: false };
		case ActionTypes.CULTURES_GET_REQUESTED:
			return { ...state, culturesLoading: true };
		case ActionTypes.CULTURES_GET_SUCCESSFUL: {
			const orderedCultures = _.orderBy(action.payload, ['cultureCode', 'displayName']);
			const availableCultures = _.map(orderedCultures, (c: ICulture, counter: number) => {
				return {
					name: c.cultureCode,
					displayText: c.name,
					disabled: false,
					displayOrder: counter,
				};
			});
			return { ...state, culturesLoading: false, availableCultures };
		}
		default:
			return { ...state };
	}
};
